import React, { useState,useRef ,useEffect} from "react";
import { Empty, Button,Checkbox,Select,TimePicker ,DatePicker,Input} from "antd";
import { CheckOutlined, CloseOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";

import "./timeSheetTable.scss";
import { getFieldStyle } from "../../themes.js";
import dayjs from 'dayjs';
import useTeamTimeSheetStore from "../../store/teamtimesheet.js";
const format = 'HH:mm';

export default function TimeSheetTableSetup({
    isClickable = false,
    titleList,
    data,
    config,
    currentView,
    alist,
    llist,
    showList = false                                  
}) {
    const navigate = useNavigate();
    const [selectAll, setSelectAll] = useState(false);
    const [selectedTSApprovar, setTSApprovar] = useState("");
    const [selectedLApprovar, setLApprovar] = useState("");
    const { assignApprovar, refreshTeamList,resetRefreshTeam } = useTeamTimeSheetStore();
    const {getTeamMembers} = useTeamTimeSheetStore()

    const selectApprovarData = alist?.map((member, idx) => {
        return {
            value:member.username,
            label:member.username,
        };
    }); 

    const checkBoxArray=data?.map((ele)=>{
        return {
            type:"",
            selected: false,
            name:ele.name,
            qhuid:ele.qhuid,
            empid:ele.empid,
            status: ""
         }
    })
    const [updateAvailable, setUpdateAvailable] = useState(false);
    const [checkBoxData, setCheckBoxData] = useState(checkBoxArray);

    const ResetCheckBox = () => {
        var checkBoxResetArray=data?.map((ele)=>{
            return {
                type:"",
                selected: false,
                name:ele.name,
                qhuid:ele.qhuid,
                empid:ele.empid,                         
                status: ""  }
        })
        setCheckBoxData(()=>([...checkBoxResetArray]))
    };
    useEffect(() => {  
        setCheckBoxData(checkBoxArray)
    }, []);

    useEffect(() => {  
        if(refreshTeamList){
            resetRefreshTeam()
            getTeamMembers()
        }
    }, [refreshTeamList]);
    

    if ((!data) || data?.length == 0) {
        return <Empty style={{ margin: "60px" }} />;
    }

    function enableDbUpdate (){
        for(let idx = 0; idx < checkBoxData?.length; idx++){
            //console.log("enableDbUpdate checkBoxArray", idx,checkBoxData[idx].selected)      
            if (checkBoxData[idx].selected ) {
                return true
            } 
        }
        return false
    }
    const onCheckBoxChange = (e) => {
        if (e.target.checked) {
            checkBoxData[e.target.value].selected = true; 
            //console.log("Setting checkBoxData", e.target.value,true,checkBoxData)      
        }else{
            checkBoxData[e.target.value].selected = false; 
            //console.log("Setting checkBoxData", e.target.value,false) 
        }
        if (enableDbUpdate() == true){
            setUpdateAvailable(true)

        }else{
            setUpdateAvailable(false)
        } 
        setCheckBoxData(()=>([...checkBoxData]))
      }


    const getUpdated=(rowIndex)=>{
        return checkBoxData?.[rowIndex]?.selected 
    }

    const handleSelectAll = () => {
        const tempCheckBoxData = [...checkBoxData];
        if (selectAll) {
        tempCheckBoxData.forEach((item) => {
            item.selected = false;
        });
        setCheckBoxData(tempCheckBoxData);
        setUpdateAvailable(false);
        } else {
        tempCheckBoxData.forEach((item) => {
            item.selected = true;
        });
        setCheckBoxData(tempCheckBoxData);
        setUpdateAvailable(true);
        }
        setSelectAll(!selectAll);
    };
  
    const handleClick= () =>{
    }
    const handleClickInfo = () =>{
    }
    const handleSelectTSApprover = (value) =>{
        setTSApprovar(value)
    }
    const handleSelectLeaveApprover = (value) =>{
        setLApprovar(value)
    }    
    function getTimeNow() {
        const today = new Date();
        const month = today.getMonth() + 1;
        const year = today.getFullYear();
        const date = today.getDate();
        const currentDate = date + "-" + month + "-" + year;
        return currentDate;
    }  
    
    const getDetails = (type,username) =>{
        var idx = -1
        if(type == "LeaveApprovar"){
            llist?.map((ele,index)=>{
            if (ele.username == username){
                idx = index
            }
        }) 
        }else{
            alist?.map(( ele,index)=>{
            if (ele.username == username){
                idx = index
            }
        })             
        }
        return idx
    }

    const encodeJson = () =>{
        let encodedJsonValues ={};
        //get company details
        const userData = JSON.parse(localStorage.getItem("userDetails"));
        //now fill the parameters
        let num=0
        encodedJsonValues.approvardetails={};
        if(selectedLApprovar != ""){
            var tmpIdx=getDetails("LeaveApprovar",selectedLApprovar)
            if(tmpIdx == -1 ){
                return encodedJsonValues
            }            
            encodedJsonValues.approvardetails.leaveapprovarname = selectedLApprovar;
            encodedJsonValues.approvardetails.leaveapprovarqhuid =llist[tmpIdx].qhuid;
            encodedJsonValues.approvardetails.leaveapprovarempid =llist[tmpIdx].empid;
            encodedJsonValues.approvardetails.leaveapprovarvalid= true;
        }
        else 
            encodedJsonValues.approvardetails.leaveapprovarvalid= false;

        if(selectedTSApprovar != ""){
            var tmpIdx=getDetails("TSApprovar",selectedTSApprovar)
            if(tmpIdx == -1 ){
                return encodedJsonValues
            }
            encodedJsonValues.approvardetails.tsapprovarname = selectedTSApprovar;
            encodedJsonValues.approvardetails.tsapprovarqhuid =alist[tmpIdx].qhuid;
            encodedJsonValues.approvardetails.tsapprovarempid =alist[tmpIdx].empid;
            encodedJsonValues.approvardetails.tsapprovarvalid= true;
        }
        else 
            encodedJsonValues.approvardetails.tsapprovarvalid= false;    

        encodedJsonValues.teammembershortdetails= []
        for(let idx = 0; idx < checkBoxData.length; idx++){
            //console.log("checkBoxData", idx,checkBoxData[idx].selected)
            if (checkBoxData[idx].selected) {
                encodedJsonValues.teammembershortdetails[num] = {}
                encodedJsonValues.teammembershortdetails[num].username = checkBoxData[idx].name;
                encodedJsonValues.teammembershortdetails[num].qhuid =checkBoxData[idx].qhuid;
                encodedJsonValues.teammembershortdetails[num].empid =checkBoxData[idx].empid;           
                num++;
            } 
        }        
        //get the current date
        let newDate = getTimeNow()
        encodedJsonValues.updatedby= userData.qhuid;
        encodedJsonValues.updatedbyname= userData.username;
        encodedJsonValues.updatedon    = newDate;
            
        return encodedJsonValues
    }
    const handleUpdates = (value) => {
        var jasonValues= encodeJson() 
        console.log("Encoded data", jasonValues)
        assignApprovar(jasonValues)
        setLApprovar("")
        setTSApprovar("")
        ResetCheckBox();
        setUpdateAvailable(false);
        setSelectAll(false)
    } 
    return (
        <div className="timeSheetTable-wrapper">
            <div className="timeSheetTable-btn-wrapper"  >
                {
                    currentView=="setup"?
                    <>
                        <Select
                            style={{ width: 130,height: 32 }}
                                     disabled={!updateAvailable}
                                     onChange={handleSelectTSApprover}
                                     placeholder= {selectedTSApprovar ==""?"Select Time Sheet Approvar":selectedTSApprovar}
                                     value={selectedTSApprovar ==""?"Select Time Sheet Approvar":selectedTSApprovar}
                                     options={selectApprovarData}
                        /> 
                        <Select
                            style={{ width: 130,height: 32 }}
                                     disabled={!updateAvailable}
                                     onChange={handleSelectLeaveApprover}
                                     value = {selectedLApprovar ==""?"Select Leave Approvar":selectedLApprovar}
                                     placeholder= {selectedLApprovar ==""?"Select Leave Approvar":selectedLApprovar}
                                     options={selectApprovarData}
                        />                                            
                        <Button
                            className="timeSheetTable-btn"
                            disabled={!updateAvailable}
                            onClick={handleUpdates}
                        >
                           Update Approvar
                        </Button>                    
                    </>                   
                    :<></>
                }                          
            </div>            
            <div
                className="table-title-wrapper"
                style={{
                    gridTemplateColumns: config
                }}
            >
                {titleList.map((title) => (
                    <div className="table-title">
                        {title === "Select" ? (
                        <Checkbox
                            className="table-title-checkbox"
                            style={{ cursor: "pointer" }}
                            onClick={() => handleSelectAll()}
                            checked={selectAll}
                        ></Checkbox>
                        ) : (
                        <p className="table-title-text">{title}</p>
                        )}
                    </div>
                ))}
            </div>
            {data?.map((table, rowIndex) => (
                <div
                    onClick={handleClick()}
                    key={table.id}
                    className="table-info-wrapper"
                    style={{
                        gridTemplateColumns: config,
                        cursor: isClickable && "pointer",
                    }}
                >
                    {Object.keys(table)?.map((tableInfo, idx) => (
                        <div className="table-info"
                             style={{
                                ...getFieldStyle(tableInfo, table[tableInfo]),
                             }}
                             onClick={()=> (tableInfo == "history")?handleClickInfo(table.id, table.qhid):"" }   
                        >
                            {tableInfo === "select" ? (
                                <Checkbox
                                className="checkbox-wrapper"
                                value={rowIndex}
                                onChange={onCheckBoxChange}
                                checked={getUpdated(rowIndex)}
                                ></Checkbox>
                            ) : (
                                <></>
                            )}                                
                            {table[tableInfo]}                               
                        </div>
                    ))}
                </div>
            ))}
        </div>
    );
}
